import React from 'react'
import ReactDOM from 'react-dom'

/*
uses Portals in React to insert dom node
at sibling of root (so that full screen overlay is easy)

does nothing stylistic
*/


const modalRoot = document.getElementById('modal-root');
class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }
  componentDidMount() {
    modalRoot.appendChild(this.el);
  }
  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }
  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/interactive/stories/root-modal.js